import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=b57bf2a6"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"
import style0 from "./uploadFile.vue?vue&type=style&index=0&id=b57bf2a6&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b57bf2a6')) {
      api.createRecord('b57bf2a6', component.options)
    } else {
      api.reload('b57bf2a6', component.options)
    }
    module.hot.accept("./uploadFile.vue?vue&type=template&id=b57bf2a6", function () {
      api.rerender('b57bf2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploadFile.vue"
export default component.exports